import { render, staticRenderFns } from "./spinner.component.vue?vue&type=template&id=09c59a1a&"
import script from "./spinner.component.vue?vue&type=script&lang=ts&"
export * from "./spinner.component.vue?vue&type=script&lang=ts&"
import style0 from "./spinner.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "spinner.component.vue"
export default component.exports